import { useState } from 'react';
import { useRouter } from 'next/router';

import { useGetListingDetails } from '../../../../hooks/queries/properties';
import accessUtils from '../../../../utils/accessUtils';

import { TRIGGER_LOCATIONS } from '../../../../constants/ClickstreamConstants';

import SFTotalMonthlyPriceWithFeeAcknowledgementModal from '../../../modals/SFTotalMonthlyPriceWithFeeAcknowledgementModal';

import PageWizard from '../../../Wizard/PageWizard';
import { CostsAndFeesStepContent } from './CostsAndFeesStepContent';

import type { WizardBodyTemplateProps } from '../../../WizardStepController';

const CostsAndFees = ({
  onGoToNextStep,
  onGoToPrevStep,
  onExitWizard,
  wizardTitle,
  progressStepper,
  totalSteps,
  currentStepIndex,
  showDesktopViewBreakpoint,
  ...rest
}: WizardBodyTemplateProps) => {
  const router = useRouter();
  const listingAlias = router.query.listingAlias as string;

  const { data: listingDetails } = useGetListingDetails(listingAlias);

  const isTotalMonthlyPriceWithFeeEligible = listingDetails?.totalMonthlyPriceWithFeeNotice?.isEligible ?? false;
  const displayTotalMonthlyPriceWithFee = listingDetails?.displayTotalMonthlyPriceWithFee ?? false;

  const canAccessTotalMonthlyPriceWithFee = accessUtils.canAccessTotalMonthlyPriceWithFee({
    isEligible: isTotalMonthlyPriceWithFeeEligible,
  });

  const [showAcknowledgementModal, setShowAcknowledgementModal] = useState(false);

  const onNextClick = () => {
    if (canAccessTotalMonthlyPriceWithFee && !displayTotalMonthlyPriceWithFee) {
      setShowAcknowledgementModal(true);
      return;
    }

    onGoToNextStep?.();
  };

  return (
    <PageWizard
      title=""
      wizardTitle={wizardTitle}
      progressStepper={progressStepper}
      totalSteps={totalSteps}
      currentStepIndex={currentStepIndex}
      onNextClick={onNextClick}
      onBackClick={onGoToPrevStep || undefined}
      onExitTriggered={onExitWizard}
      showDesktopViewBreakpoint={showDesktopViewBreakpoint}
      {...rest}
    >
      <CostsAndFeesStepContent
        showDesktopViewBreakpoint={showDesktopViewBreakpoint}
        triggerLocation={TRIGGER_LOCATIONS.POSTING_PATH}
      />

      {showAcknowledgementModal && (
        <SFTotalMonthlyPriceWithFeeAcknowledgementModal
          onClose={() => setShowAcknowledgementModal(false)}
          onSubmit={() => {
            setShowAcknowledgementModal(false);
            onGoToNextStep?.();
          }}
        />
      )}
    </PageWizard>
  );
};

export default CostsAndFees;
